export enum EEventType {
    CLICK = 'click',
    INPUT = 'input ',
    DROPDOWN = 'dropdown',
    TOGGLE = 'toggle',
    VISIBLE_ON_SCREEN = 'visibleOnScreen',
}
